module.exports = __webpack_public_path__ + "static/media/kushner-forbes.07c6bdd4.png";